<template>
  <div>
    <list-teams
      ref="list"
      :edit="editExternal"
      :filter-entity="entity"
      @create="create()"
      @remove="remove"
      @update="update"
      @view="view"
    ></list-teams>
    <form-teams
      :Edit="edit"
      :entity-id="entity._id"
      :entity-omit="true"
      :external-action="action"
      :external-team="team"
      :modal="modal"
      @close="close()"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import listTeams from '../teams/list'
import formTeams from '../teams/formManager'

export default {
  name: 'tabEquipos',
  components: {
    listTeams,
    formTeams
  },
  props: {
    editExternal: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      modal: false,
      edit: true,
      action: 'create'
    }
  },
  mounted () {
    this.initCategories()
  },
  computed: {
    ...mapState({
      entity: state => state.entities.entitySelected,
      listTeams: state => state.teams.listTeams,
      team: state => state.teams.teamSelected
    })

  },
  methods: {
    ...mapActions({
      initCategories: 'categories/setInit',
      getOne: 'entities/setOne',
      getOneTeam: 'teams/setOne',
      setClearOne: 'teams/setClearOne'
    }),
    create () {
      this.action = 'create'
      this.edit = true
      this.modal = true
    },
    update (item) {
      this.setClearOne()
      this.getOneTeam(item).catch((err) => {
        this.close()
      })
      this.action = 'update'

      this.edit = true
      this.modal = true
    },
    remove (item) {
      this.setClearOne()
      this.getOneTeam(item).catch((err) => {
        this.close()
      })
      this.action = 'remove'
      this.edit = false
      this.modal = true
    },
    view (item) {
      this.setClearOne()
      this.getOneTeam(item).catch((err) => {
        this.close()
      })
      this.action = 'view'
      this.modal = true
      this.edit = false
    },
    close () {
      this.modal = false
      this.action = ''
      this.$refs.list.status = false
      this.getOne(this.entity._id)
    }
  }
}
</script>
